export default {"src":"/_next/static/media/WhoWeAre_036A.e2220377.JPG","height":704,"width":1920};